import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTaxi } from '@fortawesome/free-solid-svg-icons';
import '../styles/TaxiLoader.css';

interface TaxiLoaderProps {
  message?: string;
}

const TaxiLoader: React.FC<TaxiLoaderProps> = ({ message = "Yükleniyor..." }) => {
  return (
    <div className="taxi-loader-overlay">
      <div className="taxi-loader-container">
        <div className="taxi-animation">
          <FontAwesomeIcon icon={faTaxi} className="taxi-icon" />
          <div className="road-line"></div>
        </div>
        <div className="loading-message">{message}</div>
        <div className="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default TaxiLoader; 